<script>
import codeTable from "@/components/table";
import topBar from "./topbar";
import { columns } from "./config";
import dayjs from "dayjs";

export const start = dayjs()
    .subtract(30, "day")
    .startOf("day")
    .format("YYYY-MM-DD HH:mm:ss");

export const end = dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss");

export default {
    created() {
        this.getList();
    },
    data() {
        return {
            pageOption: {
                data: [],
                pageQuery: {
                    total: 0,
                    pageSize: 20,
                    currentPage: 1,
                    pageSizeList: [20, 40, 60],
                },
                searchQuery: {
                    orderStatus: "",
                    orderInvoiceStatus: "",
                    orderTimeBegin: start,
                    orderTimeEnd: end,
                },
            },
            selectOption: {
                orderInvoiceStatusOps: [
                    { value: 1, label: "待开发票" },
                    { value: 2, label: "已开发票" },
                ],
            },
            params: {
                orderInvoiceStatus: 1,
            },
            rowData: null,
            editVisible: false,
        };
    },
    methods: {
        handleEdit(row) {
            this.rowData = row;
            this.editVisible = true;
        },
        onSubmit() {
            this.$http({
                method: "post",
                url: "/admin/api/order/V1.0/invoice/deal",
                params: {
                    orderId: this.rowData.orderId,
                    orderInvoiceStatus: this.params.orderInvoiceStatus,
                },
            }).then((res) => {
                this.editVisible = false;
                this.rowData = null;
                this.getList();
            });
        },
        change({ value, type }) {
            this.pageOption.pageQuery.currentPage = 1;
        },
        async getList() {
            this.$loading(true);
            const { pageQuery, searchQuery } = this.pageOption;
            const { pageSize, currentPage } = pageQuery;
            try {
                const { data } = await this.$http({
                    method: "post",
                    url: "/admin/api/order/V1.0/list",
                    params: {
                        ...searchQuery,
                        pageSize,
                        currentPage,
                    },
                });
                this.pageOption.data = (data && data.dataSource) || [];
                this.pageOption.pageQuery.total = data && data.total;
            } catch (e) {
                throw e;
            } finally {
                this.$loading(false);
            }
        },
    },
    computed: {
        columns() {
            return columns;
        },
    },
    components: {
        codeTable,
        topBar,
    },
};
</script>
<template>
    <div class="rule-list">
        <top-bar
            :handlerCodeSearch="getList"
            :searchQuery="pageOption.searchQuery"
            :selectOption="selectOption"
            @change="change"
        ></top-bar>
        <code-table
            :data="pageOption.data"
            :columns="columns"
            :searchEvent="getList"
            :pageOptions="pageOption.pageQuery"
        >
            <el-table-column
                label="操作"
                align="center"
                width="120"
                fixed="right"
                slot="operate"
            >
                <template slot-scope="scope">
                    <el-button type="success" @click="handleEdit(scope.row)"
                        >修改发票状态</el-button
                    >
                </template>
            </el-table-column>
        </code-table>

        <el-dialog title="修改发票状态" :visible.sync="editVisible" width="30%">
            <el-select
                v-model="params.orderInvoiceStatus"
                class="common-width"
                placeholder="发票状态"
            >
                <el-option
                    v-for="item in selectOption.orderInvoiceStatusOps"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
	.active
	    color #286AB1
</style>
